<template>
  <Modal
    class="scoped"
    title="Add Sub Topic"
  >
    <QCard
      v-if="topic"
      class="full-width"
    >
      <QCardSection>
        <span>
          Selected Topic: <span class="bold q-mx-md">{{ topic.name }}</span>
        </span>
      </QCardSection>
      <QCardSection>
        <QInput
          v-model="subTopic"
          dense
          filled
          label="Sub-Topic"
        />
      </QCardSection>
      <QCardActions>
        <div class="full-width flex justify-end">
          <div>
            <QBtn
              v-close-popup
              color="primary"
              flat
              label="Cancel"
              no-caps
              @click="close"
            />
            <QBtn
              color="black"
              label="Save"
              no-caps
              @click="save"
            />
          </div>
        </div>
      </QCardActions>
    </QCard>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "InsightsAddSubTopicModal",
  components: {
    Modal,
  },
  props: {
    topic: {
      type: Object,
      required: true,
    },
  },
  emits: ["confirm", "close"],
  data() {
    return {
      subTopic: "",
    };
  },
  methods: {
    async save() {
      try {
        this.topic.subTopics.push(this.subTopic);
        const success = await this.topic.save();

        if (success) {
          this.$emit("confirm", this.subTopic);
          this.close();
        } else {
          this.$error("Unable to add sub-topic");
        }
      } catch (error) {
        this.$error("Unable to add sub-topic", error);
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
